import { render, staticRenderFns } from "./handoutDetail.vue?vue&type=template&id=507472a9&scoped=true&"
import script from "./handoutDetail.vue?vue&type=script&lang=js&"
export * from "./handoutDetail.vue?vue&type=script&lang=js&"
import style0 from "./handoutDetail.vue?vue&type=style&index=0&id=507472a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507472a9",
  null
  
)

export default component.exports